import React, { useMemo } from 'react';
import { compose } from 'redux';

import { ContentMetadata } from '@candu-ai/content/types';
import { ContentPlacement } from '@candu-ai/placement/types';
import { Snapshot } from '@candu-ai/snapshots/types';
import { injectReducer } from 'commons/stores';
import { EditorWrapper } from 'craft/containers/Craft/EditorWrapper';
import { documentToCraft } from 'craft/containers/Craft/format';
import { CraftPropsContextProvider } from 'craft/contexts';
import {
  collectionsReducer,
  contextMenuReducer,
  flowsReducer,
  focusReducer,
  formsReducer,
  menuReducer,
  snapshotsReducer,
  styleguideReducer,
  tooltipsReducer,
  viewportReducer,
} from 'craft/state';
import { placementsReducer } from 'craft/state/placements';
import { ContentDocument, Schema } from 'craft/types';

/**
 * readonly: Editor does now show any edit controls, no palette or toolbox used for non editor user roles
 * locked: Editor is temporarily locked, palette and toolbar controls are disabled temporarily, Craft SDK is set to readonly
 * edit: Editor shows palette & all edit controls
 */
export type CraftMode = 'readonly' | 'edit' | 'locked';

interface Props {
  contentMetadata: ContentMetadata;
  document?: ContentDocument;
  schema?: Schema;
  onChange: (document: ContentDocument) => any;
  actionBar?: React.ReactNode;
  mode: CraftMode;
  snapshots?: Snapshot[];
  placements?: ContentPlacement[];
}

export const Craft = ({ document, onChange, actionBar }: Props) => {
  const onStateChange = (d: any) => {
    console.log('STATE CHANGE >>>>', d);
  };

  const nodes = useMemo(() => {
    if (document === undefined) {
      return undefined;
    }
    const craftNodes = documentToCraft(document);
    return craftNodes;
  }, [document === undefined]);

  return (
    <CraftPropsContextProvider contentMetadata={undefined as any} mode="edit" documentId={1}>
      <EditorWrapper
        documentId={1}
        contentId=""
        nodes={nodes}
        onStateChange={onStateChange}
        actionBar={actionBar}
        mode="edit"
      />
    </CraftPropsContextProvider>
  );
};

export default compose(
  // @ts-ignore
  injectReducer({ key: 'contextMenu', reducer: contextMenuReducer }),
  // @ts-ignore
  injectReducer({ key: 'focusManager', reducer: focusReducer }),
  // @ts-ignore
  injectReducer({ key: 'flows', reducer: flowsReducer }),
  // @ts-ignore
  injectReducer({ key: 'forms', reducer: formsReducer }),
  // @ts-ignore
  injectReducer({ key: 'tooltips', reducer: tooltipsReducer }),
  // @ts-ignore
  injectReducer({ key: 'viewport', reducer: viewportReducer }),
  // @ts-ignore
  injectReducer({ key: 'menu', reducer: menuReducer }),
  // @ts-ignore
  injectReducer({ key: 'collections', reducer: collectionsReducer }),
  // @ts-ignore
  injectReducer({ key: 'styleguide', reducer: styleguideReducer }),
  // @ts-ignore
  injectReducer({ key: 'snapshots', reducer: snapshotsReducer }),
  // @ts-ignore
  injectReducer({ key: 'placements', reducer: placementsReducer }),
  // @ts-ignore
)(Craft);
